export const CONFIG_CHANGE = 'CONFIG_CHANGE';
export const CREATED = 'CREATED';
export const DELETED = 'DELETED';
export const SCENARIO_REORDERED = 'SCENARIO_REORDERED';
export const DUPLICATED = 'DUPLICATED';
export const ANNOTATION_CREATED = 'ANNOTATION_CREATED';
export const ANNOTATION_UPDATED = 'ANNOTATION_UPDATED';
export const ANNOTATION_DELETED = 'ANNOTATION_DELETED';
